import React, { useCallback } from 'react';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useDelayed } from '../../../hooks/useDelayed';
import { CategoriesEditForm } from './CategoryFormTypes';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';
import { Hint } from '../../../_lib/components/Hint';

type CategoriesDeleteFormProps = {
  closeModal: () => void;
  refresh: () => void;
  form: CategoriesEditForm;
  title: string;
};

export function CategoriesDeleteForm({ closeModal, form, refresh, title }: CategoriesDeleteFormProps) {
  const { t } = useSonTranslation('Categories');

  const { elementType } = useBlockContext();

  const getHintLabel = () => {
    switch (elementType) {
      case BlockType.filecategories:
        return t('delete.infoTextFiles');
      case BlockType.pagetypecategories:
        return t('delete.infoTextPageTypes');
      default:
        return undefined;
    }
  };

  const headline = (
    <>
      {t('delete.category')} <Strong>„{title}“</Strong> {t('delete.question')}
    </>
  );

  const refreshAndClose = useCallback(() => {
    refresh();
    closeModal();
  }, [closeModal, refresh]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);

  const hintLabel = getHintLabel();

  return (
    <AcceptDeclineForm
      form={form}
      headline={headline}
      messageSuccess={t('delete.status.success')}
      messageSending={t('delete.status.sending')}
      messageFail={t('delete.status.fail')}
      onSuccess={delayedRefreshAndClose}
    >
      {hintLabel ? <Hint message={hintLabel} /> : null}
    </AcceptDeclineForm>
  );
}
